import { getDefaultClient } from '../../../client/defaultClient';
import { refreshAuth } from '../../user/refreshAuth';
import type { WalletAccount } from '../../wallets/walletAccount';
import { getWaasWalletProviderFromWalletAccount } from '../getWaasWalletProviderFromWalletAccount';

type DelegateWaasKeySharesParams = {
  password?: string;
  walletAccount: WalletAccount;
};

/**
 * Delegates cryptographic key shares for a WaaS wallet account.
 *
 * This function allows the delegation of key management responsibilities,
 * enabling distributed key management for enhanced security.
 *
 * @param params.walletAccount - The WaaS wallet account to delegate shares for.
 * @param [params.password] - Optional password for key share operations.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves when the key delegation is complete.
 */
export const delegateWaasKeyShares = async (
  { password, walletAccount }: DelegateWaasKeySharesParams,
  client = getDefaultClient()
): Promise<void> => {
  const provider = getWaasWalletProviderFromWalletAccount(
    { walletAccount },
    client
  );

  await provider.delegateKeyShares({
    password,
    walletAccount,
  });

  await refreshAuth(client);
};
